import { render, staticRenderFns } from "./TravelersTable.vue?vue&type=template&id=48881742&"
import script from "./TravelersTable.vue?vue&type=script&lang=js&"
export * from "./TravelersTable.vue?vue&type=script&lang=js&"
import style0 from "./TravelersTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VDatePicker,VIcon,VMenu,VSpacer,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48881742')) {
      api.createRecord('48881742', component.options)
    } else {
      api.reload('48881742', component.options)
    }
    module.hot.accept("./TravelersTable.vue?vue&type=template&id=48881742&", function () {
      api.rerender('48881742', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/VisitorApprovalPage/components/TravelersTable.vue"
export default component.exports